<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    <span v-if="isUpdate">
                        {{ $t("editar") }} {{ $t("info-saldo") }}
                    </span>
                    <span v-else>
                        {{ $t("cadastrar") }} {{ $t("info-saldo") }}
                    </span>
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="fecharModal()">
                    {{ $t("voltar") }}
                </button>
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving || cantEdit"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaSelect"
                        title="empresas"
                        label="nome"
                        :options="empresas"
                        v-model="empresaSelected"
                        required
                        :invalid="empresaSelected == null"
                        :disabled="isUpdate || cantEdit"
                        placeholder="selecione"
                        @input="loadVendedores"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(2)"
                        ref="vendedorSelect"
                        title="vendedor"
                        label="nome"
                        :options="vendedorSelect"
                        v-model="vendedorSelected"
                        :disabled="cantEdit || !empresaSelected || isUpdate"
                        searchable
                        @search="debouncedOnSearchVendedor"
                        placeholder="selecione"
                        :loading="vendedorLoading"
                        @input="edit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(3)"
                        ref="saldoInput"
                        v-model="estoque.saldo"
                        title="saldo"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.saldo)"
                        required
                        v-mask="['#######']"
                        :disabled="cantEdit"
                        tooltipLabel="info-saldo"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(4)"
                        ref="saldominimoInput"
                        v-model="estoque.saldominimo"
                        title="saldominimo"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.saldominimo)"
                        required
                        v-mask="['#######']"
                        :disabled="cantEdit"
                        tooltipLabel="info-saldomin"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(5)"
                        ref="bloqvendaforaInput"
                        title="saldo-bloqkit"
                        :options="selectSimNao"
                        v-model="bloqvendaSelected"
                        :disabled="cantEdit"
                        placeholder="selecione"
                        @input="edit"
                        tooltipLabel="info-bloqvendaforakit"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";
import SaldoProdutoService from "@/services/vendas/produto/SaldoProdutoService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService.js";
import Message from "@/models/Message";
import SaldoProdutoValidation from "@/services/validations/vendas/produto/SaldoProdutoValidation";

export default {
    props: {
        idsaldoproduto: {
            type: Number,
            default: null,
        },
        integracao: {
            type: Boolean,
            default: true,
        },
        permissao: {
            type: Object,
            default: () => {},
        },
    },
    watch: {
        estoque: {
            deep: true,
            handler: function () {
                this.editado = true;
            },
        },
    },
    data() {
        return {
            service: new SaldoProdutoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            validation: new SaldoProdutoValidation(this.msgs),

            isLoading: false,
            isSaving: false,
            msgs: [],

            estoque: {
                idsaldoproduto: this.idsaldoproduto,
                idproduto: this.$route.params.id,
                idempresa: null,
                idusuario: 0,
                saldo: null,
                saldominimo: null,
                bloqvendaforakit: 0,
                replicapda: null,
                empresa: null,
            },

            
            cantEdit: false,
            isUpdate: false,
            empresaSelected: null,
            vendedorSelect: [],
            vendedorSelected: null,
            empresas: [],
            debouncedOnSearchVendedor: null,
            searchVendedor: '',
            vendedorLoading: false,
            selectSimNao: [{id:0, label: this.$t('nao')}, {id:1, label: this.$t('sim')}],
            bloqvendaSelected: null,
            editado: false,
        };
    },
    created() {
        this.isUpdate = this.idsaldoproduto != null;
        this.debouncedOnSearchVendedor = this.debounce(this.onSearchVendedor, 500);

        if (this.isUpdate) {
            if (this.integracao) this.cantEdit = this.integracao;
            if (!this.permissao.update) this.cantEdit = !this.permissao.update;
            this.loadEmpresas()
            this.carregarDados();
        } else {
            this.loadEmpresas();
        }
    },
    methods: {
        edit(){
            this.editado = true;
        },
        loadVendedores(){
            if(this.empresaSelected){
                this.estoque.idempresa = this.empresaSelected.id
                this.vendedorLoading = true;
                this.vendedorSelected = null;
                let idempresa = this.empresaSelected.id
                this.colaboradorService
                    .findListAssociatedEmpresa(this.searchVendedor, idempresa)
                    .then((body)=> {
                        this.vendedorSelect = []
                        body.content.map((v)=>{
                            this.vendedorSelect.push({
                                id: v.idusuario,
                                nome: v.nome
                            })
                        })
                    })
                    .finally((_) => {
                        if(this.isUpdate && this.estoque.idusuario>0){
                            this.vendedorSelected = this.vendedorSelect.filter((e) => {
                                return e.id == this.estoque.idusuario
                            })[0]
                        }
                        this.vendedorLoading = false
                    })
            }
        },
        onSearchVendedor(value) {
            this.searchVendedor = this.removeToSearch(value);
            this.loadVendedores();
        },
        save() {
            if(this.vendedorSelected){
                this.estoque.idusuario = this.vendedorSelected.id;
            }
            if(this.bloqvendaSelected){
                this.estoque.bloqvendaforakit = this.bloqvendaSelected.id
            }
            if (
                this.validation.validate(
                    this.estoque,
                    this.empresaSelected,
                    this.$refs
                )
            ) {
                let estoqueTemp = Object.assign({}, this.estoque);
                estoqueTemp = this.mapTosave(estoqueTemp);
                estoqueTemp.idempresa = this.empresaSelected.id;
                this.isSaving = true;
                this.isLoading = true;
                this.service
                    .save(estoqueTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = this.$t(
                                this.estoque.idsaldoproduto != null
                                    ?'msg-edit-sucesso-n'
                                    :'msg-save-sucesso-n', 
                                { n: this.$t('aba-estoque') }
                            );
                            this.msgs.push(new Message("success", msg, true, false));
                            this.isLoading = false;
                            this.$emit("exibeMsg", msg)
                            this.editado = false;
                            this.fecharModal();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message("alert", value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message("error","msg-problema-realizar-acao",true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar: " + e);
                        this.msgs.push(
                            new Message("error", "msg-erro-salvar", true)
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(new Message("alert", "msg-campos-obrigatorios", true));
                this.isLoading = false;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.idsaldoproduto)
                .then((body) => {
                    this.estoque.idsaldoproduto = body.content.idsaldoproduto;
                    this.estoque.idproduto = body.content.idproduto;
                    this.estoque.idempresa = body.content.idempresa
                    this.empresaSelected = this.empresas.filter((e) => {
                        return e.id == this.estoque.idempresa
                    })[0]
                    this.estoque.idusuario = body.content.idusuario
                    this.estoque.saldo = body.content.saldo;
                    this.estoque.saldominimo = body.content.saldominimo;
                    this.bloqvendaSelected = this.selectSimNao.filter((e)=> {
                        return e.id == body.content.bloqvendaforakit
                    })[0]
                    this.estoque.replicapda = body.content.replicapda;
                })
                .catch((e) => {
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .then((_)=>{
                    this.loadVendedores();
                })
                .finally(() => {
                    if(this.estoque.idusuario > 0){
                        this.vendedorSelected = this.vendedorSelect.filter((e)=>{
                            return e.id == this.estoque.idusuario
                        })[0]
                    }
                    this.editado = false;
                    this.isLoading = false;
                });
        },
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: e.id, nome: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: e.id, nome: e.rsocial });
                });
            }
        },
        generateId(numberId) {
            return this.$route.name + "-estoque-" + numberId;
        },
        fecharModal() {
            if(this.editado){
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.$emit("fecharModal", true);
                    },
                    onCancel: (_) => {
                    },
                });
            } else {
                this.$emit("fecharModal", true);
            }
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 30px 30px;
}
</style>